import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";
import FilterIcon from "../../../../DefaultStyles/FilterIcon";
import Flex from "../../../../DefaultStyles/Flex";
import Loader from "../../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import Search from "../../../../Filters/Search";
import { PartyInfoFilterContainer } from "../../../Party/PartyInfo/PartyInfoFilter";
import PopupNotiModal from "./PopupNotiModal";

interface PopupNotiInfoFilterProps {
  dropDownValue: OptionType;
  setDropDownValue: Dispatch<SetStateAction<OptionType>>;
  searchValue: string | undefined;
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  pageResetEvent: () => void;
  setFilter: Dispatch<
    SetStateAction<{
      type: string;
      value: string;
    }>
  >;
  fetchEvent: () => void;
}

export default function PopupNotiInfoFilter({
  dropDownValue,
  setDropDownValue,
  setSearchValue,
  pageResetEvent,
  setFilter,
  fetchEvent,
}: PopupNotiInfoFilterProps) {
  const [filterType, setFilterType] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [filterValue, setFilterValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [popupRegisterModal, setPopupRegisterModal] = useState(false);
  const [getType, setGetType] = useState(false); // 팝업 사유 패킷 보내기
  const [typeOptionList, setTypeOptionList] = useState<OptionType[]>([]);

  const popupNotiOptionList = [
    { value: "uid", label: "UID" },
    { value: "name", label: "이름" },
    { value: "nickname", label: "닉네임" },
  ];

  const filterTypeOptionList = [
    { value: "act", label: "처리 여부" },
    { value: "type", label: "팝업 사유" },
  ];

  const actOptionList = [
    { value: "0", label: "미완료" },
    { value: "1", label: "완료" },
  ];

  // 팝업 사유 조회
  const {
    response: typeRes,
    error: typeError,
    loading: typeLoading,
  } = useApi({
    method: "get",
    url: getType ? `popup/type` : undefined,
  });

  useEffect(() => {
    const li: OptionType[] = [];

    if (typeRes?.status === 200) {
      if (typeRes?.data?.length > 0) {
        typeRes?.data?.forEach((a: any) =>
          li.push({
            value: `${a.id}`,
            label: `${a.name}`,
          })
        );

        setTypeOptionList(li);
        setGetType(false);
      }
    }
  }, [typeRes]);

  useEffect(() => {
    if (typeError) {
      toast.error(
        typeError?.data ?? "팝업 사유 리스트를 불러오는 데에 실패하였습니다."
      );
    }
  }, [typeError]);

  return (
    <PartyInfoFilterContainer maxWidth={1400}>
      <Flex gapSize={10}>
        <DropDown
          isDisabled={false}
          setDropDownValue={setDropDownValue}
          dropdownValue={dropDownValue}
          optionList={popupNotiOptionList}
          boxWidth={140}
        />

        <Search
          placeholder="입력"
          setSearchValue={setSearchValue}
          isDisabled={dropDownValue?.value === ""}
          pageResetEvent={() => pageResetEvent()}
          inputType={dropDownValue?.value === "uid" ? "number" : undefined}
        />
      </Flex>

      <Flex gapSize={10}>
        <FilterIcon maxWidth={1400} />

        <DropDown
          isDisabled={false}
          dropdownValue={filterType}
          setDropDownValue={setFilterType}
          optionList={filterTypeOptionList}
          boxWidth={140}
        />

        <div
          onClick={() => {
            if (filterType?.value === "type") {
              setGetType(true);
            }
          }}
        >
          <DropDown
            isDisabled={filterType?.value === ""}
            dropdownValue={filterValue}
            setDropDownValue={setFilterValue}
            optionList={
              filterType?.value === "act"
                ? actOptionList
                : filterType?.value === "type"
                ? typeOptionList
                : undefined
            }
            boxWidth={220}
          />
        </div>

        <ConfirmBtn
          btnColor="mint"
          btnText="적용"
          btnHeight={38}
          btnClickEvent={() => {
            pageResetEvent();
            setFilter({
              type: filterType?.value ?? "",
              value: filterValue?.value ?? "",
            });
          }}
          isDisabled={filterValue?.value === ""}
        />

        <LineBtn
          btnText="초기화"
          btnColor="mint"
          btnHeight={38}
          icon="refresh"
          disabled={filterValue?.value === ""}
          btnClickEvent={() => {
            setFilter({
              type: "",
              value: "",
            });
            setFilterType({
              value: "",
              label: "선택",
            });
            setFilterValue({
              value: "",
              label: "선택",
            });
          }}
        />

        <LineBtn
          btnHeight={38}
          icon="add"
          btnText="팝업 등록"
          btnClickEvent={() => setPopupRegisterModal(true)}
        />
      </Flex>

      {popupRegisterModal && (
        <PopupNotiModal
          closeEvent={() => setPopupRegisterModal(false)}
          confirmEvent={() => fetchEvent()}
          type="input"
        />
      )}

      {typeLoading && <Loader />}
    </PartyInfoFilterContainer>
  );
}
